<template>
  <div class="element-wrapper pb-2">
    <div class="element-search autosuggest-search-activator">
      <div class="search-suggest-input">
        <input v-on:focus="openSearch" v-model="search" :placeholder="place" type="text">
      </div>

      <div class="search-with-suggestions-w over-search-field" :class="showBox">
        <div class="search-with-suggestions-modal">
          <div class="element-search">
            <input class="search-suggest-input" v-model="search" :placeholder="place" type="text">
            <div class="close-search-suggestions"><i v-on:click="closeSearch" class="os-icon os-icon-x"></i></div>
          </div>
          <div class="search-suggestions-group" v-if="games">
            <div class="ssg-content">
              <div class="ssg-items ssg-items-list">
                <a class="ssg-item" href="javascript:void(0)" v-on:click="selectItem(event)" v-for="event in games">
                  <div class="item-media" :style="'background-image: url('+event.thumbnail+')'"></div>
                  <div class="item-name">{{ event.name | slimiter(14) }}
                  </div>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'gameAutoComplete',
    props: {
      place: {
        Type: String,
        default: 'Search game.'
      },
      group: {
        Type: String,
        default: 'Client'
      }
    },
    data () {
      return {
        t: this.$root.t,
        api: window.api,
        search: '',
        show: false,
        games: null,
        total: 0,
        selected: null
      }
    },
    watch: {
      search () {
        this.fetchD();
      }
    },
    computed: {
      showBox () {
        return (this.show) ? 'show' : 'hide';
      }
    },
    methods: {
      openSearch () {
        this.show = true;
        this.games = null;
        this.search = ''
      },
      closeSearch () {
        this.show = false;
        this.search = ''
      },
      selectItem (games) {
        this.selected = null;
        this.$emit('selected', games);
        this.selected = games;
        this.closeSearch();
      },
      fetchD () {
        this.$http.get(bsapi+'api/v1/search/casino/'+this.search, {params: {q: this.search, g: this.group} }).then(response => {
          // get body data
          this.games = response.body.result;
          this.total  = response.body.result.length;
        }, response => {

        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .search-with-suggestions-w.over-search-field.show {
    display: block
  }
  .search-with-suggestions-w.over-search-field.hide {
    display: none
  }
  .search-with-suggestions-w.over-search-field {
    top: 0px;
    left: 21px;
    width: 100%;
    max-height: 350px;
    overflow: auto;
  }
  .autosuggest-search-activator {
    position: relative;
  }
  .element-wrapper .element-search input {
    padding: 1px 45px;
  }
</style>



// WEBPACK FOOTER //
// src/components/autocomplete/gameAutoComplete.vue